import { ChevronRight } from "lucide-react";
import { Button } from "web-design-system";
import { imageAssetUrl } from "@/utils/url";
import { STATS } from "./auth-split-layout";

const APP_STORE_URL =
  "https://apps.apple.com/in/app/creso-partner/id6754884038";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=creso.partner&hl=en_IN";

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

export function DownloadAppPrompt() {
  const handleDownloadApp = () => {
    window.open(isIOS ? APP_STORE_URL : PLAY_STORE_URL, "_blank");
  };

  return (
    <>
      <div
        className="flex flex-col min-h-dvh gap-12 px-4 py-12 pb-32"
        style={{
          background: "linear-gradient(180deg, #EFF0EA 0%, #FEF3C7 100%)",
        }}
      >
        <img
          src={imageAssetUrl("logo-dark.png")}
          alt="Creso"
          className="h-5 w-auto self-start px-8"
        />

        <div className="flex flex-col gap-4">
          <div className="font-semibold leading-tight text-black text-2xl px-8">
            Everything Mutual Fund Distributors Need in{" "}
            <span className="text-orange-700">One Platform</span>
          </div>
          <img
            src={imageAssetUrl("product-hero-image.png")}
            alt="Creso dashboard showing a distributor's client AUM, asset allocation, and mutual fund portfolio in one view."
            className="w-full h-auto object-contain"
          />

          <div className="flex items-center justify-center">
            <div className="flex flex-col gap-8">
              {STATS.map((stat) => {
                const { icon: Icon, value, label } = stat;

                return (
                  <div key={label} className="flex items-center gap-6">
                    <div className="flex items-center justify-center shrink-0 size-12 rounded-lg bg-orange-50 text-orange-700">
                      <Icon className="size-6" />
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="font-semibold text-xl text-black">
                        {value}
                      </span>
                      <span className="text-lg text-[#78716C] whitespace-nowrap">
                        {label}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-auto flex flex-col px-8 items-center justify-center">
          <span className="text-black text-lg border-t border-[#78716C] w-full py-8 text-center">
            Get started by downloading the <br /> Creso Partner app
          </span>
        </div>
      </div>

      <div className="fixed inset-x-0 bottom-0 px-10 py-8">
        <Button
          size="lg"
          onClick={handleDownloadApp}
          className="w-full h-auto justify-between p-4 rounded-2xl gap-3 flex shadow-xl bg-black"
        >
          <span className="text-base text-white">Download Now for Free</span>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5">
              <img
                src={imageAssetUrl("app-store.webp")}
                alt="App Store"
                className="size-8 rounded-md"
              />
              <img
                src={imageAssetUrl("play-store.webp")}
                alt="Google Play"
                className="size-8 rounded-md -ml-2"
              />
            </div>
            <ChevronRight className="size-6 text-white" />
          </div>
        </Button>
      </div>
    </>
  );
}
